import React, { Component } from 'react';
import { spring, StaggeredMotion } from 'react-motion';

import ShowcaseCollectionCard from 'components/ShowcaseCollection/ShowcaseCollectionCard';
import PropTypes from 'prop-types';

function resolveShowcaseImage(enableIconAsImage, icon, headerImages) {
  if (enableIconAsImage && icon) return icon;
  return headerImages[0];
}

export default class ShowcaseCollection extends Component {
  constructor(props) {
    super(props);

    this.timer = null;
    this.state = {
      showcaseCollection: [],
    };
  }

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  init() {
    const showcaseCollection = this.props.stands;
    const { language, enableIconAsImage } = this.props;

    const startingValues = Object.keys(showcaseCollection).map(() => {
      return {
        data: 0,
        pos: 20,
      };
    });

    const items = (
      <StaggeredMotion
        defaultStyles={startingValues}
        styles={(prevInterpolatedStyles) => {
          return prevInterpolatedStyles.map((_, i) => {
            return i === 0
              ? {
                  data: spring(1, { stiffness: 320, damping: 28 }),
                  pos: spring(0, { stiffness: 320, damping: 28 }),
                }
              : {
                  data: spring(prevInterpolatedStyles[i - 1].data, {
                    stiffness: 320,
                    damping: 28,
                  }),
                  pos: spring(prevInterpolatedStyles[i - 1].pos, {
                    stiffness: 320,
                    damping: 28,
                  }),
                };
          });
        }}
      >
        {(styles) => {
          return (
            <React.Fragment>
              {showcaseCollection.map((showcase, i) => {
                const { propertyName, headerImages, icon, type, id, description } = showcase;
                const style = {
                  opacity: `${styles[i].data}`,
                  transform: `translateY(${styles[i].pos}%)`,
                };

                if (!propertyName) {
                  return null;
                }

                return (
                  <React.Fragment>
                    <div key={id} className="ShowcaseCollectionCard__Animated" style={style}>
                      <ShowcaseCollectionCard
                        appId={import.meta.env.VITE_APP_ID}
                        key={id}
                        index={i}
                        image={resolveShowcaseImage(enableIconAsImage, icon, headerImages)}
                        subtitle={description}
                        title={propertyName}
                        type={type}
                        itemID={id}
                        language={language}
                      />
                    </div>
                  </React.Fragment>
                );
              })}
            </React.Fragment>
          );
        }}
      </StaggeredMotion>
    );

    this.setState({ showcaseCollection: items });
  }

  render() {
    return (
      <div className="showcaseCollection__Grid">
        {this.state.showcaseCollection}
        <style>
          {
            '\
        .fancybox-slide--iframe .fancybox-content { max-width  : 960px; margin: 0; } '
          }
        </style>
      </div>
    );
  }
}

ShowcaseCollection.propTypes = {
  language: PropTypes.string,
  stands: PropTypes.arrayOf(PropTypes.object).isRequired,
  enableIconAsImage: PropTypes.bool,
};

ShowcaseCollection.defaultProps = {
  language: 'en',
  enableIconAsImage: false,
};
